import app from 'flarum/forum/app';
import EventPost from 'flarum/forum/components/EventPost';
import currencySymbol from '../../common/currencySymbol';
export default class BountyAddedEventPost extends EventPost {
  icon() {
    return 'fas fa-hand-holding-heart';
  }
  description(data) {
    return m("span", null, app.translator.trans('floxum-payments.forum.post_stream.bounty_added_text', data));
  }
  descriptionData() {
    const post = this.attrs.post;
    const amount = post.content().amount / 100;
    const currency = post.content().currency;
    return {
      amount: m("strong", {
        className: "BountyAddedEventPost-amount"
      }, currencySymbol(currency), " ", amount)
    };
  }
}
flarum.reg.add('floxum-payments', 'forum/Discussion/BountyAddedEventPost', BountyAddedEventPost);